"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
* -webkit-   Used by Chrome, Safari, Android, & iOS
* -moz-      Used by Mozilla Firefox
* -o-        Used by Opera
* -ms-       Used by Internet Explorer
*/
exports.default = ["webkit", "moz", "ms", "o", ""];
//# sourceMappingURL=vendors.js.map